<template>
  <b-modal id="modalRemoveReconciliation" centered title="Remove Reconciliation" title-class="font-18" size="md"
    @hide="resetForm">
    <b-tabs v-model="selectedTab" pills justified>

      <b-tab title="Pagarme">
        <div class="mt-3">
          <label for="transactionIDPagarme" class="form-label">Transaction ID (Pagarme)</label>
          <b-form-input id="transactionIDPagarme" v-model="transactionIDPagarme" placeholder="Digite o Transaction ID"
            :state="!errorsFrom.transactionIDPagarme" />
          <b-form-invalid-feedback v-if="errorsFrom.transactionIDPagarme">
            {{ errorsFrom.transactionIDPagarme }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>

      <b-tab title="IUGU">
        <div class="mt-3">
          <label for="transactionIDIugu" class="form-label">Transaction ID (IUGU)</label>
          <b-form-input id="transactionIDIugu" v-model="transactionIDIugu" placeholder="Digite o Transaction ID"
            :state="!errorsFrom.transactionIDIugu" />
          <b-form-invalid-feedback v-if="errorsFrom.transactionIDIugu">
            {{ errorsFrom.transactionIDIugu }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>

      <b-tab title="WORLDPAY">
        <div class="mt-3">
          <label for="transactionIDWorldpay" class="form-label">Transaction ID (WORLDPAY)</label>
          <b-form-input id="transactionIDWorldpay" v-model="transactionIDWorldpay" placeholder="Digite o Transaction ID"
            :state="!errorsFrom.transactionIDWorldpay" />
          <b-form-invalid-feedback v-if="errorsFrom.transactionIDWorldpay">
            {{ errorsFrom.transactionIDWorldpay }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>
      <b-tab title="CIELO">
        <div class="mt-3">
          <label for="transactionIDCielo" class="form-label">Transaction ID (CIELO)</label>
          <b-form-input id="transactionIDCielo" v-model="transactionIDCielo" placeholder="Digite o Transaction ID"
            :state="!errorsFrom.transactionIDCielo" />
          <b-form-invalid-feedback v-if="errorsFrom.transactionIDCielo">
            {{ errorsFrom.transactionIDCielo }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>
      <b-tab title="MERCADO PAGO">
        <div class="mt-3">
          <label for="transactionIDMercadoPago" class="form-label">Transaction ID (MERCADO PAGO)</label>
          <b-form-input id="transactionIDMercadoPago" v-model="transactionIDMercadoPago" placeholder="Digite o Transaction ID"
            :state="!errorsFrom.transactionIDMercadoPago" />
          <b-form-invalid-feedback v-if="errorsFrom.transactionIDMercadoPago">
            {{ errorsFrom.transactionIDMercadoPago }}
          </b-form-invalid-feedback>
        </div>
      </b-tab>
    </b-tabs>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="success" @click="submitData">Concluir</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import OperationsService from '@services/resources/OperationsService';

const service = OperationsService.build();

export default {
  name: 'modalRemoveReconciliation',
  data() {
    return {
      selectedTab: 0,
      transactionIDPagarme: '',
      transactionIDIugu: '',
      transactionIDWorldpay:'',
      transactionIDCielo:'',
      transactionIDMercadoPago:'',
      errorsFrom: {},
    };
  },
  methods: {
    validateFields() {
      this.errorsFrom = {};

      const fields = [
        { key: 'transactionIDPagarme', value: this.transactionIDPagarme },
        { key: 'transactionIDIugu', value: this.transactionIDIugu },
        { key: 'transactionIDWorldpay', value: this.transactionIDWorldpay },
        { key: 'transactionIDCielo', value: this.transactionIDCielo },
        { key: 'transactionIDMercadoPago', value: this.transactionIDMercadoPago }
      ];

      const currentField = fields[this.selectedTab];
      if (!currentField.value.trim()) {
        this.errorsFrom[currentField.key] = 'O campo Transaction ID é obrigatório.';
      }

      return Object.keys(this.errorsFrom).length === 0;
    },
    async submitData() {
      if (!this.validateFields()) return;
      const tabsBody = [
        this.transactionIDPagarme,
        this.transactionIDIugu,
        this.transactionIDWorldpay,
        this.transactionIDCielo,
        this.transactionIDMercadoPago
      ]

      const tabsService = [
        'remove-reconciliation-pagarme',
        'remove-reconciliation-iugu',
        'remove-reconciliation-worldpay',
        'remove-reconciliation-cielo',
        'remove-reconciliation-mercadopago'
      ]

      try {
        await service.post(tabsService[this.selectedTab], {transactionID: tabsBody[this.selectedTab]});

        this.$bvToast.toast('Conciliação removida com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalRemoveReconciliation');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao enviar';

        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          message = Object.values(error.response.data.errors)
            .flat()
            .join('\n');
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },
    resetForm() {
      this.transactionIDPagarme = '';
      this.transactionIDIugu = '';
      this.transactionIDWorldpay = '';
      this.transactionIDCielo = '';
      this.transactionIDMercadoPago = '';
      
      this.errorsFrom = {};
      this.selectedTab = 0;
    },
  },
};
</script>
